import { useCallback } from 'react';

import { hexToBigInt } from 'viem';
import { useAccount, useConnections, useSendTransaction, useSwitchAccount } from 'wagmi';

import { wagmiConfig } from '@pkg/providers';
import { type StepItem } from '@pkg/types';

export function useTransaction() {
    const { chainId } = useAccount();
    const { switchAccountAsync } = useSwitchAccount({ config: wagmiConfig });
    const { sendTransactionAsync } = useSendTransaction();
    const connections = useConnections();

    return useCallback(
        async (currentItem: StepItem) => {
            const transactionData = currentItem?.data;
            const { value, maxFeePerGas, maxPriorityFeePerGas, domain, gas } = transactionData || {};

            // todo - dedup & switch in useWalletConnections maybe
            if (domain?.chainId && chainId && chainId !== domain?.chainId) {
                const connector = connections.find((connection) => {
                    const connectionChain = connection.chainId;
                    return connectionChain == domain?.chainId;
                })?.connector;
                if (connector) {
                    await switchAccountAsync({
                        connector,
                    });
                }
            }

            const bigInts = {
                value: hexToBigInt(value || 0),
                ...(maxFeePerGas && {
                    maxFeePerGas: hexToBigInt(maxFeePerGas),
                }),
                ...(maxPriorityFeePerGas && {
                    maxPriorityFeePerGas: hexToBigInt(maxPriorityFeePerGas),
                }),
                ...(gas && {
                    gas: hexToBigInt(gas),
                }),
            };

            await sendTransactionAsync({
                ...transactionData,
                ...bigInts,
            });
        },
        [chainId, connections, sendTransactionAsync, switchAccountAsync],
    );
}
